// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"345":"23f87803","656":"6a219bf5","756":"547504ff","831":"4777ac0b","968":"afc92492"}[chunkId] + ".chunk.js";
};